import React, { useState } from 'react';
import { emailRegex, FormState } from '@opu/utils';
import { auth } from '../../../firebase-init';

import { useTranslation } from 'react-i18next';

const useForm = () => {
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);

  const { t, i18n } = useTranslation();

  const firebaseLogin = async () => {
    setLoading(true);

    auth
      .signInWithEmailAndPassword(formState.inputValues.email, formState.inputValues.password)
      .then(async (result) => {
        const tokenId = await result.user.getIdToken();
        setLoading(false);
      })
      .catch((error) => {
        switch (error.code) {
          case 'auth/user-not-found':
            setErrors(t('login.errors.user-not-found'));
            break;

          case 'auth/wrong-password':
            handleErrorsServer(['ERROR_PASSWORD_INVALID']);
            break;

          case 'auth/invalid-email':
            handleErrorsServer(['ERROR_EMAIL_PATTERN']);
            break;

          default:
            setErrors(t('login.errors.authentication-error'));
            break;
        }

        setLoading(false);
      });
  };

  const inputValues = {
    email: { value: '', validate: { required: true, pattern: emailRegex } },
    password: { value: '', validate: { required: true } },
  };

  const { formState, submitHandler, field, handleErrorsServer } = FormState(inputValues, firebaseLogin);

  return {
    submitHandler,
    field,
    firebaseLogin,
    setErrors,
    errors,
    loading,
  };
};

export default useForm;
